import { GQL_ID } from '@@partner:types:graphql'
import type { Category } from '@@partner:types:app'

import { mergeLeft, mergeLeftDropping } from 'merge-left-utils'

import { CATEGORY_STATUS_ENABLED } from '@@partner:config/category'
import { DEFAULT_LOCALES } from '@@partner:config/locale'


export interface CategoryFormState extends Omit<Category, 'id'> {
  id?: GQL_ID
  languages: string[]
}

export const CATEGORY_DEFAULT_STATE: CategoryFormState = {
  id: undefined,
  xid: undefined,
  parent_id: undefined,
  parent: {
    id: undefined,
    name: undefined
  },
  status: CATEGORY_STATUS_ENABLED,
  name: '',
  featured: false,
  assembler_order: 0,
  customer_order: 0,
  slug: '',
  icon: {
    url: undefined
  },
  altIcon: {
    url: undefined
  },
  miniIcon: {
    url: undefined
  },
  icon_id: undefined,
  alternative_icon_id: undefined,
  mini_icon_id: undefined,
  languages: DEFAULT_LOCALES,
  preview_size: 'standard',
  i18n: [],
  ignore_exchange_changes: false,
}

export const makeCategoryFormState = (category?: Category): CategoryFormState => {
  const state = {
    ...category,
    languages: category?.i18n.length && category?.i18n.length > 0 ? category?.i18n?.map((i18n) => i18n.language_code) : DEFAULT_LOCALES,
  }
  
  return mergeLeft<CategoryFormState>(CATEGORY_DEFAULT_STATE, state)
}

// state and api variable are same excluding info fields
// so drop them and go
export const mapStateToApiVariable = (state: CategoryFormState): any =>
  mergeLeftDropping([ 'icon', 'altIcon', 'miniIcon', 'parent', 'languages' ], CATEGORY_DEFAULT_STATE, {
    ...state,
    parent_id: state?.parent?.id,
    status: Number(state.status),
    assembler_order: Number(state.assembler_order),
    customer_order: Number(state.customer_order),
    i18n: state.i18n?.map((i18n) => ({
      language_code: i18n.language_code,
      name: i18n.name
    }))
  })

export const mapApiDataToState = (data: Category) => makeCategoryFormState(data)
